import createReducer from 'lib/create-reducer'
import { constants } from './actions'
import saga from './sagas'

const defaultState = {
  loading: false,
  verified: false,
  expired: false
}

const verifyEmail = createReducer(defaultState, {
  [constants.VERIFY_EMAIL]: state => ({
    ...state,
    loading: true
  }),
  [constants.VERIFY_EMAIL_SUCCESS]: state => ({
    ...state,
    loading: false,
    verified: true
  }),
  [constants.VERIFY_EMAIL_EXPIRED]: state => ({
    ...state,
    loading: false,
    expired: true
  })
}, saga)

export default verifyEmail
